import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <CardsSection />
        <CommentsSection />
        <ContactSection />
        <FaqSection />
        <TopicsSection />
        <FeaturesSection />
        <IndexSection />
        <UpdatesSection />
        <CarouselSection />
        <AboutSection />
        <RankingSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}